export default {
  indicators: [],

  standard_dates: {
    init_date: "",
    end_date: ""
  },

  filter: {
    init_date: "",
    end_date: "",
    seller: null,
    credit: [],
    base_debt: "",
    coverage: [],
    chain: [],
    pos: [],
    customer_document: ""
  }
}
